"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkFilterSetupForBackend = exports.getSubtitle = exports.getNumberOfSelectedItems = exports.createFilter = exports.getBackend = exports.isCancelablePromisePendingOrLoading = exports.isCancelablePromiseLoading = exports.isCancelablePromisePending = exports.getInitialIsInverted = exports.getInitialSelectedOptions = void 0;
var tslib_1 = require("tslib");
var AttributeFilterUtils_1 = require("../utils/AttributeFilterUtils");
var sdk_model_1 = require("@gooddata/sdk-model");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var isNil_1 = tslib_1.__importDefault(require("lodash/isNil"));
/**
 * Gets the selection from the initial {@link @gooddata/sdk-model#IAttributeFilter} object.
 */
exports.getInitialSelectedOptions = function (currentFilter) {
    // the as any cast is ok here, the data will get fixed once the element load completes
    // this serves only to have some initial state here so that when full element data is loaded
    // it automatically sets the props.filter.elements as selected
    return currentFilter
        ? AttributeFilterUtils_1.attributeElementsToAttributeElementArray(sdk_model_1.filterAttributeElements(currentFilter))
        : [];
};
/**
 * Gets the isInverted property from the initial {@link @gooddata/sdk-model#IAttributeFilter} object.
 */
exports.getInitialIsInverted = function (currentFilter) {
    return currentFilter ? sdk_model_1.isNegativeAttributeFilter(currentFilter) : true;
};
exports.isCancelablePromisePending = function (cancelablePromiseStatus) {
    return cancelablePromiseStatus === "pending";
};
exports.isCancelablePromiseLoading = function (cancelablePromiseStatus) {
    return cancelablePromiseStatus === "loading";
};
exports.isCancelablePromisePendingOrLoading = function (cancelablePromiseStatus) {
    return (exports.isCancelablePromiseLoading(cancelablePromiseStatus) ||
        exports.isCancelablePromisePending(cancelablePromiseStatus));
};
/**
 * Applies a telemetry to the {@link @gooddata/sdk-backend-spi#IAnalyticalBackend} object.
 */
exports.getBackend = function (backend, props) {
    return backend.withTelemetry("AttributeFilter", props);
};
/**
 * Creates the new {@link @gooddata/sdk-model#IAttributeFilter} with the actual selection
 * and actual inverted state property.
 */
exports.createFilter = function (filter, isInverted, selectedFilterOptions, identifier, emptyFilter) {
    if (emptyFilter === void 0) { emptyFilter = false; }
    var useUriElements = filter && sdk_model_1.isAttributeElementsByRef(sdk_model_1.filterAttributeElements(filter));
    var filterFactory = isInverted || emptyFilter ? sdk_model_1.newNegativeAttributeFilter : sdk_model_1.newPositiveAttributeFilter;
    var items = emptyFilter ? [] : selectedFilterOptions;
    return filterFactory(AttributeFilterUtils_1.getObjRef(filter, identifier), useUriElements
        ? { uris: items.map(function (item) { return item.uri; }) }
        : { values: items.map(function (item) { return item.title; }) });
};
/**
 * Returns number of selected elements. If the selection is inverted, it returns
 * the number of all elements of the attribute without the actual selection,
 * the size of the actual selection otherwise.
 */
exports.getNumberOfSelectedItems = function (originalTotalCount, filterOptions, isInverted) {
    if (isInverted) {
        return originalTotalCount - filterOptions.length;
    }
    return filterOptions.length;
};
/**
 * Gets the subtitle according to current selection and loading status of the component.
 */
exports.getSubtitle = function (props) {
    var loadingProps = props.loadingProps, ownProps = props.ownProps, state = props.state;
    if (loadingProps.isElementsLoading && !isEmpty_1.default(state.searchString)) {
        return "";
    }
    if (loadingProps.isTotalCountLoading) {
        if (state.firstLoad) {
            return AttributeFilterUtils_1.getLoadingTitleIntl(ownProps.intl);
        }
        else if (state.isFiltering) {
            return AttributeFilterUtils_1.getFilteringTitleIntl(ownProps.intl);
        }
    }
    if (ownProps.isAllFiltered) {
        return AttributeFilterUtils_1.getAllTitle(ownProps.intl);
    }
    var displayForm = AttributeFilterUtils_1.getObjRef(ownProps.currentFilter, ownProps.identifier);
    if (state.uriToAttributeElementMap.size > 0 && !isNil_1.default(ownProps.originalTotalCount) && displayForm) {
        /**
         * If the attribute filter is positive, `getNumberOfSelectedItems` returns current size of
         * the `selectedFilterOptions` array. If the filter is negative attribute filter, it
         * returns difference between `originalTotalCount` and current size of the selection.
         *
         * If the number of selected items is 0 and originalTotalCount is greater than 0, it is
         * considered the selection is empty.
         */
        var empty = exports.getNumberOfSelectedItems(ownProps.originalTotalCount, state.selectedFilterOptions, state.isInverted) === 0 && ownProps.originalTotalCount > 0;
        /**
         * All items are selected only in case the number of selected items is equal to original total
         * count.
         */
        var all = exports.getNumberOfSelectedItems(ownProps.originalTotalCount, state.selectedFilterOptions, state.isInverted) === ownProps.originalTotalCount;
        var getAllPartIntl = all ? AttributeFilterUtils_1.getAllTitle(ownProps.intl) : AttributeFilterUtils_1.getAllExceptTitle(ownProps.intl);
        if (empty) {
            return AttributeFilterUtils_1.getNoneTitleIntl(ownProps.intl);
        }
        if (all) {
            return getAllPartIntl;
        }
        return state.isInverted
            ? getAllPartIntl + " " + AttributeFilterUtils_1.getItemsTitles(state.selectedFilterOptions, state.uriToAttributeElementMap, ownProps.isElementsByRef)
            : "" + AttributeFilterUtils_1.getItemsTitles(state.selectedFilterOptions, state.uriToAttributeElementMap, ownProps.isElementsByRef);
    }
    return "";
};
exports.checkFilterSetupForBackend = function (filter, backend) {
    var isSupportElementUris = backend.capabilities.supportsElementUris;
    var isElementsByRef = sdk_model_1.isAttributeElementsByRef(sdk_model_1.filterAttributeElements(filter));
    if (isSupportElementUris && !isElementsByRef) {
        // eslint-disable-next-line no-console
        console.error("The attribute elements must be defined by URIs for this backend.");
    }
};
//# sourceMappingURL=AttributeFilterButtonUtils.js.map